<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required}"
            :for="name">
            {{ label }}
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div :class="[marginTop ? marginTop : 'mt-1']">
            <ValidationProvider :name="label" mode="passive" :rules="rules" v-slot="{ errors }" tag="div">
                <div :class="[marginTop ? marginTop : 'mt-1']" class="relative">
                    <datetime
                        v-model="model"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm leading-none text-gray-700 datetime-theme"
                        :class="{ 'border-red-700' : errors[0], 'opacity-50 cursor-not-allowed' : disabled }"
                        :id="name"
                        @input="onInput"
                        :name="name"
                        :placeholder="placeholder ? placeholder : ''"
                        :disabled="readonly"
                        autocomplete="Off"
                        data-lpignore="true"
                        :type="type"
                        :format="format"
                        :min-datetime="minDatetime"
                        :auto="auto"
                        :value="initialValue"
                        :use12-hour="use12Hour"
                        :minute-step="minuteStep">
                    </datetime>
                    <font-awesome-icon class="absolute right-0 top-0 mr-3 mt-3 text-gray-700 z-999 cursor-pointer"
                        :icon="['fas', 'times']"
                        @click="clear"
                        v-if="model"/>
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    import { Datetime } from 'vue-datetime';
    import { Settings } from 'luxon';

    export default {
        name: "InputDateTime",
        props: ['label', 'value', 'name', 'placeholder', 'readonly', 'rules', 'mask', 'required', 'type', 'tooltip', 'dollar', 'disabled', 'format', 'minDatetime', 'auto', 'initialValue', 'watchInitial', 'use12Hour', 'minuteStep', 'marginTop'],
        components: {
            datetime: Datetime
        },
        data: function(){
            return {
                model: null
            }
        },
        beforeMount: function(){
            Settings.defaultLocale = 'au';

            if (this.initialValue){
                this.model = this.initialValue;
            }

        },
        methods: {
            onInput () {
                this.$emit('input', this.model)
            },
            clear (){
                this.model = null;
                this.$emit('input', this.model)
            }
        },
        watch: {
            initialValue: function(newVal, oldVal){

                if (this.watchInitial){
                    if (newVal !== oldVal){
                        this.model = newVal;
                        this.$emit('input',this.model);
                    } else if (!newVal){
                        this.model = null;
                        this.$emit('input', null);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
